<template>
    <div>
        <div class="card-header">

        </div>
        <div class="card-body text-center">
            <h3>Invoice payment delayed</h3>
        </div>
    </div>
</template>

<script>
  import DefaultState from './DefaultState';

  export default {
    name: 'Delayed',
    extends: DefaultState,
  };
</script>

<style scoped>
</style>
